import { render, staticRenderFns } from "./OpenCardsStats.vue?vue&type=template&id=595a8833&"
import script from "./OpenCardsStats.vue?vue&type=script&lang=ts&"
export * from "./OpenCardsStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports